"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconZoom = void 0;
var React = __importStar(require("react"));
var IconZoom = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M10.5,17.9952014 C14.636,17.9952014 18,14.6322103 18,10.4974508 C18,6.36269119 14.636,2.99970009 10.5,2.99970009 C6.364,2.99970009 3,6.36269119 3,10.4974508 C3,14.6322103 6.364,17.9952014 10.5,17.9952014 Z M21.854,21.1462561 C22.049,21.343197 22.049,21.6591023 21.853,21.8530441 C21.755,21.9510147 21.628,22 21.5,22 C21.372,22 21.244,21.9510147 21.146,21.8530441 L16.156,16.8525442 C16.15,16.8475457 16.148,16.8405478 16.144,16.8345496 C14.641,18.1731481 12.667,18.9949015 10.5,18.9949015 C5.813,18.9949015 2,15.1830451 2,10.4974508 C2,5.81185644 5.813,2 10.5,2 C15.187,2 19,5.81185644 19,10.4974508 C19,12.6608018 18.181,14.6312106 16.844,16.1337599 C16.85,16.1387584 16.858,16.1407578 16.864,16.1457563 L21.854,21.1462561 Z M11,5.99880036 L11,9.99760072 L15,9.99760072 L15,10.9973008 L11,10.9973008 L11,14.9961012 L10,14.9961012 L10,10.9973008 L6,10.9973008 L6,9.99760072 L10,9.99760072 L10,5.99880036 L11,5.99880036 Z" }))); };
exports.IconZoom = IconZoom;
exports.IconZoom.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconZoom;
